module.exports = __webpack_public_path__ + "img/doc.1dc50336.png";